export default function Clock({ time }) {
  return (
    <div>
      <h1>{time}</h1>
      <input />
    </div>
  );
}
